import PropTypes from 'prop-types'

import LinkButton from '../ui/LinkButton'
import styles from './DetallePie.module.css'

const DetallePie = ({ idPublicacion, esVentas }) => {
  return (
    <div className={styles.detallePie}>
      {!esVentas && idPublicacion !== null && (
        <LinkButton className={styles.btnSuccess} to={`/Publicacion/${idPublicacion}`}>
          Volver a Comprar
        </LinkButton>
      )}
      <LinkButton className={styles.btnDanger} to="/Reclamar">
        Reclamar!
      </LinkButton>
    </div>
  )
}

export default DetallePie

DetallePie.propTypes = {
  idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  esVentas: PropTypes.bool
}
